import { resolveDemoArtifact } from './artifactPayloadDemoResolvers.js'
import { payloadsById } from './artifactPayloadStore.part01.js'

function hasStoredPreviewPayload(stored) {
  const markdown = stored?.payload?.markdown
  const html = stored?.payload?.html
  const pdfUrl = stored?.payload?.url
  const documentId = stored?.payload?.documentId
  return [markdown, html, pdfUrl, documentId].some(
    (value) => typeof value === 'string' && value.trim(),
  )
}

export function resolveArtifactForPreview(selection) {
  const artifactId = selection?.artifactId
  if (!artifactId) return null

  const stored = payloadsById.get(artifactId)
  if (hasStoredPreviewPayload(stored)) return stored

  const artifact = resolveDemoArtifact(artifactId, selection)
  if (artifact) {
    payloadsById.set(artifactId, artifact)
    return artifact
  }

  return stored ?? null
}

/** Clears store (tests only). */

export function resetArtifactPayloadStoreForTests() {
  payloadsById.clear()
}
